<div class="p-5 md:p-8" data-testid="hr-tool-comparison">
  @if (tools().length) {
    <!-- Top bar: back + clear all -->
    <div class="mb-6 flex items-center justify-between gap-4">
      <button type="button" class="hr-back-link" (click)="back()" data-testid="comparison-back">
        <i class="pi pi-arrow-left"></i>
        {{ 'hrTool.comparison.back' | transloco }}
      </button>
      <button
        type="button"
        class="hr-compare-clear"
        (click)="clearAll()"
        data-testid="comparison-clear"
      >
        {{ 'hrTool.comparison.button.removeAllTools' | transloco }}
      </button>
    </div>

    <!-- Title -->
    <div class="mb-8">
      <p class="text-button-red text-[10px] font-semibold uppercase tracking-[0.35em]">
        {{ 'hrTool.comparison.eyebrow' | transloco }}
      </p>
      <h1 class="text-2xl font-bold tracking-tight md:text-3xl">
        {{ tools().length }} {{ 'hrTool.comparison.countLabel' | transloco }}
      </h1>
    </div>

    <!-- Product header cards -->
    <div class="hr-compare-grid mb-8" [style.--cols]="tools().length">
      @for (tool of tools(); track tool.id) {
        <div class="card relative p-5" [attr.data-testid]="'comparison-card-' + tool.id">
          <button
            type="button"
            class="hr-compare-card-remove"
            (click)="remove(tool.id)"
            [attr.aria-label]="toolName(tool)"
            [attr.data-testid]="'comparison-remove-' + tool.id"
          >
            <i class="pi pi-times"></i>
          </button>

          <div class="mb-4 flex h-20 items-center justify-center">
            @if (tool.coverImage) {
              <img
                [src]="tool.coverImage"
                [alt]="toolName(tool)"
                class="max-h-full max-w-full object-contain"
                (error)="hideBrokenImage($event)"
              />
            } @else {
              <span class="text-lg font-bold text-muted-color">{{ toolName(tool) }}</span>
            }
          </div>

          <p class="text-button-red mb-1 text-[10px] font-semibold uppercase tracking-widest">
            {{ applicationTypeLabel(tool) }}
          </p>
          <h3 class="mb-2 text-sm font-semibold">{{ toolName(tool) }}</h3>
          @if (description(tool); as text) {
            <div class="line-clamp-3 text-xs text-muted-color">
              <app-safe-html-output [html]="text" />
            </div>
          }
        </div>
      }
    </div>

    <!-- Comparison tables: functions, service model, languages, countries -->
    @for (section of sections(); track section.title) {
      <div
        class="card mb-6 overflow-hidden p-0!"
        [attr.data-testid]="'comparison-section-' + section.title"
      >
        <div class="border-themed border-b px-5 py-3">
          <h2 class="text-sm font-bold">{{ section.title | transloco }}</h2>
        </div>
        @for (item of section.items; track item.key) {
          <div class="hr-compare-row" [style.--cols]="tools().length">
            <div class="hr-compare-row__label">
              @if (item.flagUrl) {
                <img [src]="item.flagUrl" alt="" class="mr-2 inline-block h-3 w-4 object-contain" />
              }
              {{ item.label }}
            </div>
            @for (tool of tools(); track tool.id) {
              <div class="hr-compare-row__cell">
                @if (section.has(tool, item.key)) {
                  <i class="pi pi-check text-emerald-500"></i>
                } @else {
                  <i class="pi pi-times text-red-400"></i>
                }
              </div>
            }
          </div>
        }
      </div>
    }

    <app-hr-tool-ai-capability-comparison [tools]="tools()" />
  } @else {
    <div class="py-16 text-center" data-testid="comparison-empty">
      <p class="mb-4 text-muted-color">{{ 'hrTool.comparison.empty' | transloco }}</p>
      <button type="button" class="hr-link" (click)="back()">
        {{ 'hrTool.comparison.back' | transloco }}
      </button>
    </div>
  }
</div>
